/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetFloorplans200ResponseValueTablesInner } from './GetFloorplans200ResponseValueTablesInner';
import {
    GetFloorplans200ResponseValueTablesInnerFromJSON,
    GetFloorplans200ResponseValueTablesInnerFromJSONTyped,
    GetFloorplans200ResponseValueTablesInnerToJSON,
    GetFloorplans200ResponseValueTablesInnerToJSONTyped,
} from './GetFloorplans200ResponseValueTablesInner';

/**
 * 
 * @export
 * @interface GetFloorplans200ResponseValue
 */
export interface GetFloorplans200ResponseValue {
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValue
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValue
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseValue
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseValue
     */
    controlPrinter: string | null;
    /**
     * 
     * @type {Array<GetFloorplans200ResponseValueTablesInner>}
     * @memberof GetFloorplans200ResponseValue
     */
    tables: Array<GetFloorplans200ResponseValueTablesInner>;
}

/**
 * Check if a given object implements the GetFloorplans200ResponseValue interface.
 */
export function instanceOfGetFloorplans200ResponseValue(value: object): value is GetFloorplans200ResponseValue {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('controlPrinter' in value) || value['controlPrinter'] === undefined) return false;
    if (!('tables' in value) || value['tables'] === undefined) return false;
    return true;
}

export function GetFloorplans200ResponseValueFromJSON(json: any): GetFloorplans200ResponseValue {
    return GetFloorplans200ResponseValueFromJSONTyped(json, false);
}

export function GetFloorplans200ResponseValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFloorplans200ResponseValue {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'position': json['position'],
        'controlPrinter': json['controlPrinter'],
        'tables': ((json['tables'] as Array<any>).map(GetFloorplans200ResponseValueTablesInnerFromJSON)),
    };
}

export function GetFloorplans200ResponseValueToJSON(json: any): GetFloorplans200ResponseValue {
    return GetFloorplans200ResponseValueToJSONTyped(json, false);
}

export function GetFloorplans200ResponseValueToJSONTyped(value?: GetFloorplans200ResponseValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'position': value['position'],
        'controlPrinter': value['controlPrinter'],
        'tables': ((value['tables'] as Array<any>).map(GetFloorplans200ResponseValueTablesInnerToJSON)),
    };
}

